import OfferResaleModal from './offer-resale-modal';
export default OfferResaleModal;